// Ekran 11 — Giriş. Kabuksuz, iki adımlı (K1: oturum tesis bazlıdır).
// Markup ve sınıf adları ref_files/btys-erp-11-giris.html'den birebir alındı;
// yalnız demo JS'i gerçek API akışıyla değiştirildi.

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiHatasi } from '../../lib/api'
import { useOturum, type GirisYanit, type Tesis } from '../../lib/oturum'
import '../../styles/giris.css'

const TesisIkonu = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" />
  </svg>
)

export default function GirisSayfasi() {
  const { girisYap, tesisSec, sistemeGir } = useOturum()
  const yonlendir = useNavigate()

  const [eposta, setEposta] = useState('mehmet.kaya@yesilenerji.com.tr')
  const [sifre, setSifre] = useState('')
  const [sifreAcik, setSifreAcik] = useState(false)
  const [hata, setHata] = useState<string | null>(null)
  const [bekliyor, setBekliyor] = useState(false)

  const [adim2, setAdim2] = useState<GirisYanit | null>(null)
  const [secili, setSecili] = useState<string | null>(null)

  async function adim1Gonder() {
    if (bekliyor) return
    setHata(null)
    setBekliyor(true)
    try {
      const yanit = await girisYap(eposta.trim(), sifre)

      // Süper admin 2. adımı ATLAR: seçecek tesisi yok, doğrudan sistem
      // paneline gidiyor. Kullanıcı isteği: "giriş sayfası aynı olsun, süper
      // admin ilgili sayfaya yönlensin."
      if (yanit.sistemYoneticisi) {
        await sistemeGir(yanit.gecisJetonu)
        yonlendir('/sistem', { replace: true })
        return
      }

      setAdim2(yanit)
      // YALNIZ tek tesis varsa peşin seç. Liste alfabetik geldiği için "ilkini seç"
      // demek, kullanıcıyı sessizce yanlış tesise sokabilirdi; oturum tesis bazlı
      // olduğundan (K1) bu seçim bilinçli olmalı.
      setSecili(yanit.tesisler.length === 1 ? yanit.tesisler[0].id : null)
    } catch (e) {
      setHata(e instanceof ApiHatasi ? e.message : 'Beklenmeyen bir hata oluştu.')
    } finally {
      setBekliyor(false)
    }
  }

  async function panelegit() {
    if (!adim2 || !secili || bekliyor) return
    setHata(null)
    setBekliyor(true)
    try {
      await tesisSec(adim2.gecisJetonu, adim2.kullanici, secili)
      yonlendir('/', { replace: true })
    } catch (e) {
      setHata(e instanceof ApiHatasi ? e.message : 'Beklenmeyen bir hata oluştu.')
    } finally {
      setBekliyor(false)
    }
  }

  // Referans ekran Enter ile 1. adımı gönderiyor.
  useEffect(() => {
    const dinle = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return
      if (adim2) void panelegit()
      else void adim1Gonder()
    }
    document.addEventListener('keydown', dinle)
    return () => document.removeEventListener('keydown', dinle)
  })

  const bas = (k: { ad: string }) =>
    k.ad
      .split(' ')
      .map((p) => p[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()

  return (
    <div className="sf-giris">
      <section className="hero">
        <div className="hbrand">
          <div className="hmark">B</div>
          <div>
            <div className="hname">BTYS</div>
            <div className="hsub">Biyogaz Tesisi Yönetim Sistemi</div>
          </div>
        </div>
        <div className="hmid">
          <h1>Hammadde tedarikinden elektrik satışına — tek zincir.</h1>
          <p>
            Mal kabul, laboratuvar, besleme rasyonu, üretim beyanı, filo ve stok denetimi; tek veri
            modelinde, mutabakatlı ve izlenebilir.
          </p>
          <div className="feat">
            <div className="fi">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                <path d="M9 11l3 3 8-8" />
                <path d="M21 12a9 9 0 1 1-9-9" />
              </svg>
            </div>
            <div>
              <b>Günlük mutabakat motoru</b>
              <span>Besleme ↔ beyan ↔ stok, toleranslarla (K9 · K17)</span>
            </div>
          </div>
          <div className="feat">
            <div className="fi">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <div>
              <b>Silinemez denetim defteri</b>
              <span>Storno/revizyon disiplini, tam izlenebilirlik (K15)</span>
            </div>
          </div>
          <div className="feat">
            <div className="fi">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" />
              </svg>
            </div>
            <div>
              <b>Çok tesisli mimari</b>
              <span>Şirket → tesisler; satır düzeyinde veri izolasyonu (K1 · K3)</span>
            </div>
          </div>
        </div>
        <div className="hfoot">
          <span>v2.0 referans</span>
          <span>·</span>
          <span>PostgreSQL RLS</span>
          <span>·</span>
          <span>.NET 8 + React</span>
        </div>
      </section>

      <section className="pane">
        <div>
          <div className={adim2 ? 'card s2' : 'card'}>
            <div className="step1">
              <div className="ct">Tesise giriş yapın</div>
              <div className="cs">Kurumsal e-posta adresiniz ve şifrenizle devam edin</div>
              <div className={hata && !adim2 ? 'err on' : 'err'}>{hata}</div>
              <div className="fld">
                <label htmlFor="em">E-posta</label>
                <input
                  className="in"
                  id="em"
                  type="email"
                  autoComplete="username"
                  value={eposta}
                  onChange={(e) => setEposta(e.target.value)}
                />
              </div>
              <div className="fld">
                <label htmlFor="pw">Şifre</label>
                <input
                  className="in"
                  id="pw"
                  type={sifreAcik ? 'text' : 'password'}
                  autoComplete="current-password"
                  value={sifre}
                  onChange={(e) => setSifre(e.target.value)}
                />
                <button
                  className="eye"
                  type="button"
                  title="Şifreyi göster/gizle"
                  onClick={() => setSifreAcik((a) => !a)}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
              </div>
              <div className="row">
                <span className="rem">
                  <span className="tgl on" />
                  Beni hatırla
                </span>
                <a className="lnk" href="#" onClick={(e) => e.preventDefault()}>
                  Şifremi unuttum
                </a>
              </div>
              <button className="btn btn-pri" type="button" disabled={bekliyor} onClick={() => void adim1Gonder()}>
                {bekliyor ? 'Kontrol ediliyor…' : 'Giriş yap'}
              </button>
            </div>

            <div className="step2">
              <div className="ct">Tesis seçin</div>
              <div className="cs">
                Yetkili olduğunuz tesisler listelenir — oturum tesis bazlıdır (K1)
              </div>
              {adim2 && (
                <>
                  <div className="who">
                    <span className="av">{bas(adim2.kullanici)}</span>
                    <div>
                      <b>{adim2.kullanici.ad}</b>
                      <span>
                        {adim2.kullanici.eposta}
                        {adim2.kullanici.unvan ? ` · ${adim2.kullanici.unvan}` : ''}
                      </span>
                    </div>
                  </div>
                  <div className={hata ? 'err on' : 'err'}>{hata}</div>
                  {/* Referans ekranda bunlar onClick'li düz div. Sınıf adlarını
                      koruyup radio semantiği ekliyoruz: tesis seçimi oturumun
                      kapsamını belirliyor (K1), klavyeyle erişilemez olamaz. */}
                  <div role="radiogroup" aria-label="Tesis seçin">
                    {adim2.tesisler.map((t: Tesis) => (
                      <div
                        key={t.id}
                        role="radio"
                        tabIndex={t.aktif ? 0 : -1}
                        aria-checked={secili === t.id}
                        aria-disabled={!t.aktif}
                        className={
                          !t.aktif ? 'tes dis' : secili === t.id ? 'tes on' : 'tes'
                        }
                        onClick={() => t.aktif && setSecili(t.id)}
                        onKeyDown={(e) => {
                          if (!t.aktif) return
                          if (e.key === ' ' || e.key === 'Enter') {
                            e.preventDefault()
                            e.stopPropagation()
                            setSecili(t.id)
                          }
                        }}
                      >
                        <span className="ti">
                          <TesisIkonu />
                        </span>
                        <div>
                          <b>{t.ad}</b>
                          <span>
                            {t.aktif
                              ? [t.il, t.kod].filter(Boolean).join(' · ')
                              : 'kurulum aşamasında — erişim kapalı'}
                          </span>
                        </div>
                        {/* Referans: .tes.dis satırında span.rad HİÇ basılmaz. */}
                        {t.aktif && <span className="rad" />}
                      </div>
                    ))}
                  </div>
                  <button
                    className="btn btn-pri"
                    type="button"
                    style={{ marginTop: 8 }}
                    disabled={!secili || bekliyor}
                    onClick={() => void panelegit()}
                  >
                    {bekliyor ? 'Açılıyor…' : 'Panele git →'}
                  </button>
                  <button
                    className="btn btn-sso"
                    type="button"
                    onClick={() => {
                      setAdim2(null)
                      setSecili(null)
                      setHata(null)
                      setSifre('')
                    }}
                  >
                    ← Farklı hesapla gir
                  </button>
                </>
              )}
            </div>

            <div className="cfoot">
              Giriş yaparak <a href="#" onClick={(e) => e.preventDefault()}>Kullanım Koşulları</a> ve{' '}
              <a href="#" onClick={(e) => e.preventDefault()}>KVKK Aydınlatma Metni</a>&apos;ni kabul
              etmiş olursunuz.
              <br />© 2026 BTYS · Sürüm 2.0 · Oturum 8 saat işlemsizlikte kapanır
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
